import { Component, OnInit, Inject} from '@angular/core';
import { Validators, FormGroup, FormControl} from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { AssetService } from '../assetservice';
import { AssetForCreationResponse,AssetForEditCreation} from '../asset';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar'
import { SessionCheck,generateAlertMessage, AuthFailedMessage } from '../../../app-general';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AlertSharedService } from '../../../_services/index';
import { ApiService } from '../../../api.service';
import { checkTagId } from '../../../api';
import { appsettings } from '../../../app-settings';

@Component({
  selector: 'app-edit-asset',
  templateUrl: './edit-asset.component.html',
  providers: [ AssetService],
  styleUrls: ['./edit-asset.component.scss']
})
export class EditAssetComponent implements OnInit {
  watcher: Subscription;
  columns: number = 8; 
  SiteId = "1";
  assetid;
  oldTagId;  
  public EditassetCreationForm : FormGroup; 
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditAssetComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private AssetService: AssetService,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService, 
  private alertSharedService: AlertSharedService,public dialog: MatDialog) 
  { 
        
    this.assetid = data.AssetId;
    this.oldTagId = data.TagId;
      this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
        if (change) {
          if (change.mqAlias == 'xs') {
            this.columns = 3;            
          } 
          else if (change.mqAlias == 'sm') {
            this.columns = 4;
          }         
          else {
            this.columns = 8;
          }
        }
      });
  }

  ngOnInit() {
     this.EditassetCreationForm = new FormGroup({
        tagid: new FormControl('', [Validators.required, Validators.maxLength(10),Validators.max(1073741823),Validators.min(1), Validators.pattern(appsettings.Number_Pattern)]),
        assetname: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
        assetnamealias: new FormControl('', [Validators.required,Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
        assettype: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
      });
  }
  public onCloseAsset = () => {
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.EditassetCreationForm.controls[controlName].hasError(errorName);
  }
  public EditcreateAsset = (assetCreationForm) => {   
    if(!SessionCheck(this.router))
    {
      this.thisDialogRef.close('Cancel');
        return;
    } 
    if (this.EditassetCreationForm.valid) {                    
        this.checkTagId(assetCreationForm);                         
    }
  }

  checkTagId(assetCreationForm)
  {   
    
    try
    {
      (document.activeElement as HTMLTextAreaElement).blur();


      if(this.EditassetCreationForm.valid)
      {        
        let saveclick = document.getElementById('btnsaveclick');
        saveclick.className = 'clsbtnAsseteditSave mat-raised-button disablebtn'; 

        var tagidfoundItem : checkTagId = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          newTagId: parseInt(assetCreationForm.tagid), 
          resStaffId: parseInt(this.assetid) 
        } 
        this.apiService.checkTagId(tagidfoundItem).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : any[])=>{           
            if (apiresponse!=null && apiresponse!=undefined)
            {   
              if(apiresponse.toString() == "not found")
              { 
                this.updateAsset(assetCreationForm);                       
              }            
              else 
              { 
                if(apiresponse[0].desc == 'Resident' || apiresponse[0].desc == 'Staff')                
                {
                  generateAlertMessage(this.dialog,"Duplicate Tag Id found, the Asset "+apiresponse[0].desc+"  '"+ apiresponse[0].name+"'  already has this tagid.<br> Please try again with different Tag Id");                                            
                  saveclick.className = 'clsbtnAsseteditSave mat-raised-button'; 
                  return;
                }
                else if(apiresponse[0].desc == 'Asset')                
                {
                  generateAlertMessage(this.dialog,"Duplicate Tag Id found, the Asset '"+ apiresponse[0].name+"'  already has this tagid.<br> Please try again with different Tag Id");                                            
                  saveclick.className = 'clsbtnAsseteditSave mat-raised-button'; 
                  return;
                }
                else                
                {
                  generateAlertMessage(this.dialog,"Duplicate Tag Id found, the Asset '"+apiresponse[0].name+"' already has this tagid on "+ apiresponse[0].desc+".<br> Please try again with different Tag Id");                                 
                  saveclick.className = 'clsbtnAsseteditSave mat-raised-button'; 
                  return;
                }
              }
            }
            else
            {            
              generateAlertMessage(this.dialog, 'Asset details edited failed.') 
              saveclick.className = 'clsbtnAsseteditSave mat-raised-button'; 
              return;           
            }
          });     
      }
    }
    catch (err) {
      throw new Error('edit-asset.component.ts' + ' - checkTagId() - ' + err.message);
    }    
  } 
  

  updateAsset(assetCreationForm)
  {

        try
        {
          let saveclick = document.getElementById('btnsaveclick');
          saveclick.className = 'clsbtnAsseteditSave mat-raised-button disablebtn'; 

           let e_asset: AssetForEditCreation = {            
            authKey: localStorage.getItem("Authkey"),
            tagId: assetCreationForm.tagid,
            assetName : assetCreationForm.assetname.replace(/\s+/g, ' ').trim(),
            assetNameAlias: assetCreationForm.assetnamealias.replace(/\s+/g, ' ').trim(),
            assetType : assetCreationForm.assettype.replace(/\s+/g, ' ').trim(),
            assetId :parseInt(this.assetid)
          }                  
            this.AssetService.updateAsset(e_asset).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : AssetForCreationResponse[])=>{
              if (apiresponse!=null && apiresponse!=undefined)
              { 
                if(apiresponse["apiReturn"] == "Success")
                { 	                                 
                  generateAlertMessage(this.dialog, 'Asset details edited successfully.')                  
                }
                else if(apiresponse["apiReturn"] == "Fail")
                {                  
                  generateAlertMessage(this.dialog, 'Asset details edited failed.')                  
                }
                else if (apiresponse["apiReturn"] == "Invalid Auth Key") {
                  this.thisDialogRef.close("close");
                  AuthFailedMessage(this.dialog, this.router);
                  return;
                }               
              }
              else
              {                
                generateAlertMessage(this.dialog, 'Asset details edited failed.')               
              }
              this.thisDialogRef.close('Confirm');
            });
        
        }
        catch (err) {
          throw new Error('edit-notification.component.ts' + ' - updateAsset() - ' + err.message);
        }
           
  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.EditassetCreationForm.controls).forEach(field => { // {1}
        const control = this.EditassetCreationForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-staff.component.ts' + ' - handleInput() - ' + err.message);
    }
  }
ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}

}
